import api from 'Application/api/api';

const getTotals = signal =>
	api.get('/finances/totals', {
		signal,
	});

export default getTotals;
